import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Brossedents = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.75 82.25">
  <G fill={color}>
    <Path d="M60.87,21.38c-.83-.83-2.02-1.06-3.06-.72l-6.62-6.62c.29-1.12.45-2.27.45-3.46,0-3.67-1.43-7.12-4.02-9.71-1.17-1.17-3.07-1.17-4.24,0l-18,18c-2.59,2.59-4.02,6.04-4.02,9.71s1.43,7.12,4.02,9.71c.56.56,1.33.88,2.12.88s1.56-.32,2.12-.88l1.6-1.6,5.05,5.05L.88,77.13c-1.17,1.17-1.17,3.07,0,4.24.59.59,1.35.88,2.12.88s1.54-.29,2.12-.88l37.5-37.5s0,0,0,0,0,0,0,0l18.25-18.25c1.17-1.17,1.17-3.07,0-4.24ZM27.35,28.59c0-2.07.8-4.01,2.27-5.47l15.46-15.46c.37.92.57,1.9.57,2.92,0,2.06-.8,3.99-2.25,5.45l-14.3,14.3s0,0,0,0l-1.17,1.17c-.37-.92-.57-1.9-.57-2.92ZM35.46,32.47l1.45-1.45.92.92c.59.59,1.35.88,2.12.88s1.54-.29,2.12-.88c1.17-1.17,1.17-3.07,0-4.24l-.92-.92,1.45-1.45.92.92c.59.59,1.35.88,2.12.88s1.54-.29,2.12-.88c1.17-1.17,1.17-3.07,0-4.24l-.92-.92.78-.78s0,0,0,0l.66-.66,5.05,5.05-12.83,12.83-5.04-5.05Z"/>
  </G>
</Svg>
);
};

export default Brossedents;
